import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/router'

import * as css from './styles'
import { INavProps } from '../DashboardLayout.types'
const Subnav = dynamic(() => import('./Subnav'))

const Navigation = ({ brandColor, items, isMobile, styles }: INavProps) => {
  const { pathname } = useRouter()

  return (
    <nav css={{ ...css.navWrapper(isMobile, brandColor), ...styles }}>
      <ul>
        {items.map(props => {
          const { id, link, secondaryLink, name, icon, subnav, externalLink } =
            props

          const subnavActive =
            subnav?.filter(
              i => i.link === pathname || i.secondaryLink === pathname
            ).length > 0

          return (
            <li
              css={subnav && css.subnav(brandColor)}
              key={id}
              id={id}
              className={
                pathname ===
                  (link?.split('?')[0] || secondaryLink?.split('?')[0]) ||
                subnavActive
                  ? 'active'
                  : null
              }
            >
              {link && (
                <Link href={link}>
                  {icon}
                  <span>{name}</span>
                </Link>
              )}
              {subnav && (
                <Subnav
                  initial={subnavActive}
                  brandColor={brandColor}
                  icon={icon}
                  name={name}
                  subnav={subnav}
                />
              )}
              {externalLink && (
                <a
                  href={externalLink}
                  target='_blank'
                  rel='noreferrer noopener'
                >
                  {icon}
                  <span>{name}</span>
                </a>
              )}
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Navigation
